import { render } from "./Ship_agents.vue?vue&type=template&id=4fc38a3d"
import script from "./Ship_agents.vue?vue&type=script&lang=js"
export * from "./Ship_agents.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__